"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.disable = exports.enable = void 0;
var enable_1 = require("./enable");
Object.defineProperty(exports, "enable", { enumerable: true, get: function () { return enable_1.enable; } });
var disable_1 = require("./disable");
Object.defineProperty(exports, "disable", { enumerable: true, get: function () { return disable_1.disable; } });
